import { Media } from 'media'
import { ComponentType } from 'react'
import { FooterDesktop } from './FooterDesktop'
import { FooterMobile } from './FooterMobile'

export const Footer: ComponentType = () => (
  <>
    <Media at="xs">
      <FooterMobile />
    </Media>
    <Media greaterThan="xs">
      <FooterDesktop />
    </Media>
  </>
)
